module.exports = __webpack_public_path__ + "static/media/mesh.172d18ce.gif";